import { TextField } from '@mui/material';
import styled from 'styled-components';

export const SearchInput = styled(TextField)`
  width: 100%;
  padding: var(--sizes-30) 10px var(--sizes-30) var(--sizes-40);
  background-color: var(--color-gray-10);
  border-radius: 6px;
  outline: 1px solid transparent;

  :hover {
    outline-color: var(--color-gray-80);
  }

  :focus,
  :focus-within {
    background-color: var(--color-brand-primary-white);
    outline-color: var(--color-brand-secondary-sapphire);

    .MuiInputAdornment-positionEnd {
      opacity: 1;
    }
  }

  .MuiInputBase-root {
    color: var(--color-gray-80);
    font: var(--font-regular-14pt-normal);
    padding-right: 0;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }

  .MuiOutlinedInput-input {
    height: auto;
    padding: 0;

    ::placeholder {
      opacity: 1;
    }
  }

  .MuiInputAdornment-root {
    margin-right: 12px;
  }

  .MuiInputAdornment-positionEnd {
    margin-right: 0;
    background-color: var(--color-gray-10);
    opacity: 0;
  }

  .MuiInputBase-adornedStart {
    padding-left: 0;
  }

  input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50em;
    background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_400_1019)'%3E%3Crect width='20' height='20' fill='white'/%3E%3Cpath d='M20 10C20 8.02219 19.4135 6.08879 18.3147 4.4443C17.2159 2.79981 15.6541 1.51809 13.8268 0.761209C11.9996 0.00433286 9.98891 -0.193701 8.0491 0.192152C6.10929 0.578004 4.32746 1.53041 2.92894 2.92894C1.53041 4.32746 0.578004 6.10929 0.192152 8.0491C-0.193701 9.98891 0.00433286 11.9996 0.761209 13.8268C1.51809 15.6541 2.79981 17.2159 4.4443 18.3147C6.08879 19.4135 8.02219 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10ZM13.925 12.7333C14.0802 12.8895 14.1673 13.1007 14.1673 13.3208C14.1673 13.541 14.0802 13.7522 13.925 13.9083C13.8475 13.9864 13.7554 14.0484 13.6538 14.0907C13.5523 14.1331 13.4433 14.1548 13.3333 14.1548C13.2233 14.1548 13.1144 14.1331 13.0129 14.0907C12.9113 14.0484 12.8191 13.9864 12.7417 13.9083L10.15 11.3167C10.1101 11.2804 10.0581 11.2602 10.0042 11.2602C9.95023 11.2602 9.89823 11.2804 9.85834 11.3167L7.26667 13.9083C7.10725 14.0449 6.90219 14.1162 6.69246 14.1081C6.48273 14.1 6.28378 14.0131 6.13537 13.8646C5.98696 13.7162 5.90001 13.5173 5.89191 13.3075C5.88381 13.0978 5.95515 12.8928 6.09167 12.7333L8.68334 10.1417C8.71964 10.1018 8.73976 10.0498 8.73976 9.99584C8.73976 9.9419 8.71964 9.8899 8.68334 9.85L6.09167 7.25834C6.01356 7.18087 5.95157 7.0887 5.90926 6.98715C5.86695 6.8856 5.84517 6.77668 5.84517 6.66667C5.84517 6.55666 5.86695 6.44774 5.90926 6.34619C5.95157 6.24464 6.01356 6.15247 6.09167 6.075C6.24781 5.9198 6.45902 5.83268 6.67917 5.83268C6.89933 5.83268 7.11054 5.9198 7.26667 6.075L9.85834 8.66667C9.87704 8.6866 9.89963 8.70249 9.92472 8.71334C9.9498 8.7242 9.97684 8.7298 10.0042 8.7298C10.0315 8.7298 10.0585 8.7242 10.0836 8.71334C10.1087 8.70249 10.1313 8.6866 10.15 8.66667L12.7417 6.075C12.8194 5.99731 12.9116 5.93567 13.0131 5.89362C13.1146 5.85157 13.2235 5.82993 13.3333 5.82993C13.4432 5.82993 13.552 5.85157 13.6535 5.89362C13.7551 5.93567 13.8473 5.99731 13.925 6.075C14.0027 6.1527 14.0643 6.24494 14.1064 6.34646C14.1484 6.44798 14.1701 6.55679 14.1701 6.66667C14.1701 6.77655 14.1484 6.88536 14.1064 6.98688C14.0643 7.0884 14.0027 7.18064 13.925 7.25834L11.3333 9.85C11.3134 9.86871 11.2975 9.8913 11.2867 9.91638C11.2758 9.94146 11.2702 9.96851 11.2702 9.99584C11.2702 10.0232 11.2758 10.0502 11.2867 10.0753C11.2975 10.1004 11.3134 10.123 11.3333 10.1417L13.925 12.7333Z' fill='%23A0A8AB'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_400_1019'%3E%3Crect width='20' height='20' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
  }

  input[type='search']:focus::-webkit-search-cancel-button {
    opacity: 1;
    pointer-events: all;
  }
`;
